import { X } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import useBreakpoint from 'src/shared/hooks/use-breakpoint'

const ChevronLeftIcon = ({ size = 28 }: { size: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 8 15" fill="none">
      <path
        d="M0 7.50003C0 7.32566 0.0651655 7.15111 0.195332 7.01799L6.86196 0.199815C7.12246 -0.066605 7.54429 -0.066605 7.80463 0.199815C8.06496 0.466235 8.06512 0.897655 7.80463 1.1639L1.60932 7.50003L7.80463 13.8362C8.06512 14.1026 8.06512 14.534 7.80463 14.8002C7.54413 15.0665 7.1223 15.0667 6.86196 14.8002L0.195332 7.98208C0.0651655 7.84895 0 7.67441 0 7.50003Z"
        fill="currentColor"
      />
    </svg>
  )
}

type SettingsMobileNavigationProps = {
  hideCloseButton?: boolean
  hideBackButton?: boolean
  onBack?: () => void
  onClose?: () => void
  isEnterprise?: boolean
}

const SettingsMobileNavigation = ({
  hideCloseButton = false,
  hideBackButton = false,
  isEnterprise = false,
  onBack: customOnBack,
  onClose: customOnClose,
}: SettingsMobileNavigationProps) => {
  const { isMobile } = useBreakpoint()
  const navigate = useNavigate()

  const onGoBack = () => {
    if (customOnBack) {
      customOnBack()
    } else {
      navigate(-1)
    }
  }

  const onClose = () => {
    if (customOnClose) {
      customOnClose()
    } else {
      if (isEnterprise) {
        navigate('/enterprise/dashboard/settings')
      } else {
        navigate('/dashboard/settings')
      }
    }
  }

  if (!isMobile) {
    return null
  }

  return (
    <div className="flex flex-row justify-between gap-4 p-5">
      {!hideBackButton && (
        <button type="button" className="flex items-center justify-center gap-2.5 rounded-full" onClick={onGoBack}>
          <ChevronLeftIcon size={16} />
        </button>
      )}
      {!hideCloseButton && (
        <button
          type="button"
          className="flex size-10 items-center justify-center gap-2.5 rounded-full bg-accent"
          onClick={onClose}
        >
          <X size={20} className="text-primary" />
        </button>
      )}
    </div>
  )
}

export default SettingsMobileNavigation
